import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Link,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "../../context/ThemeContext";
import { getAppTheme } from "../../config/resolve-app-brand";

const ProgressModal = ({ open, demoReady, onClose, onStartExperience }) => {
  const { isDarkMode } = useTheme();
  const theme = getAppTheme(isDarkMode);

  return (
    <Dialog
      open={open}
      onClose={false}
      disableEscapeKeyDown={true}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "8px",
          p: 2,
        },
      }}
      data-testid="progress-modal--Dialog-0">
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          color: theme.palette.primary.main,
          pb: 2,
        }}
        data-testid="progress-modal--DialogTitle-0">
        We're preparing your Demo Business File!
      </DialogTitle>
      <DialogContent data-testid="progress-modal--DialogContent-0">
        <Box sx={{ textAlign: "left", lineHeight: 1.6 }}>
          <Typography sx={{ mb: 2 }}>
            Your file will be loaded with over 2 years of data: Journals, Bills, Invoices, Timesheets and Payroll. You can open, edit and delete records, and run all reports, to explore Exacc in a real environment.
          </Typography>
          
          <Box component="ul" sx={{ mb: 3, pl: 2 }}>
            <Typography component="li" sx={{ mb: 1 }}>
              You will find bank feeds awaiting your processing. Go to Menu: Books &gt; Process Feeds.
            </Typography>
            <Typography component="li" sx={{ mb: 1 }}>
              You can also import transaction (csv) files and process them in your demo file.
            </Typography>
            <Typography component="li" sx={{ mb: 1 }}>
              To invite your team, log in to the Business File and click on Menu: Manage &gt; Invite User, and follow instructions. As all e-mails in Demo Files are diverted to your e-mail, you will need to forward the invitations to your team manually.
            </Typography>
            <Typography component="li" sx={{ mb: 1 }}>
              Also, lodging ATO reports is disabled in demo files.
            </Typography>
            <Typography component="li" sx={{ mb: 1 }}>
              Demo files may be deleted without notice after 14 days, but you can get a new one any time.
            </Typography>
          </Box>
          
          <Box sx={{ textAlign: "center", mt: 4 }}>
            {demoReady ? (
              <Link
                component="button"
                onClick={onStartExperience}
                sx={( theme )=>({
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  color: theme.palette.primary.main,
                  borderColor: theme.palette.primary.main,
                  borderWidth: "1px",
                  borderStyle: "solid",
                  borderRadius: "8px",
                  padding: "12px 24px",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                })}
                data-testid="progress-modal--Link-0">
                Your demo is ready! Click here to start your Exacc Experience!
              </Link>
            ) : (
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                <CircularProgress size={40} />
                <Typography
                  sx={{
                    fontWeight: "bold",
                    color: theme.palette.primary.main,
                  }}
                >
                  We'll be ready in less than a minute!
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProgressModal;